import {
  borderRadius,
  borderSize,
  breakpoint,
  opacity,
  palette,
  shadow,
  space,
  typography,
  zIndex,
} from '@sds-system/theme';
import type { Theme } from '@sds-system/types';
import { modalDefaultProps } from './components/modal';
import { size } from './size';

export const theme: Theme = {
  palette: palette,
  borderSize: borderSize,
  borderRadius: borderRadius,
  opacity: opacity,
  space: space,
  shadow: shadow,
  typography: typography,
  zIndex: zIndex,
  size: size,
  breakpoint: breakpoint,
  components: {
    Modal: {
      defaultProps: modalDefaultProps,
    },
  },
};
